import * as Sentry from '@sentry/capacitor';

export async function safePromise<T>(promise: Promise<T>): Promise<[T, null] | [null, Error]> {
  try {
    const result = await promise;
    return [result, null];
  } catch (error) {
    Sentry.captureException(error);

    if (error instanceof Error) {
      return [null, error];
    }

    return [null, new Error('An unknown error occurred.')];
  }
}
